/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Radio, Select, Space, Modal, Form, Input } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { getPopupContainer } from '../../../../../../../helpers/popUp';

import Style from './style';
import { ModalHeader } from 'datastake-daf/dist/components';

export default function ModalFilters({
  initialFilters = [],
  setFiltersVisible = () => { },
  filtersVisible = false,
  setActiveFilters = () => { },
  clearFilters = false,
  setClearFilters = () => { },
  t = (t) => t,
  onSubmit = null,
  title = null,
}) {
  const [filters, setFilters] = useState([]);

  const initializeFilters = useCallback((clear) => {
    if (filters.length) {
      setFilters((filters) => filters.map((f) => {
        const initialFilter = initialFilters.find((i) => i.key === f.key);
        if (initialFilter && f) {
          if (clear) {
            return initialFilter;
          }
          if (f.value) {
            return { ...initialFilter, value: f.value };
          }
        }
        return initialFilter || {};
      }));
    } else {
      setFilters(initialFilters);
    }
  }, [initialFilters, filters]);

  useEffect(() => {
    initializeFilters();
  }, [initialFilters]);

  const handleChange = (e, contIndex, type) => {
    setFilters(filters.map((container, i) => {
      if (i === contIndex) {
        if (e && e.target) {
          const value = e.target.value;
          return { ...container, value };
        }
        if (type === 'select') {
          return { ...container, value: e };
        }
      }
      return container;
    }));
  };

  const applyFiltersHandler = useCallback(() => {
    const activeFilters = {};
    filters.forEach((filter) => {
      if (filter.type === 'radioGroup' || filter.type === 'select' || filter.type === 'textInput') {
        if (filter.value) {
          activeFilters[filter.key] = filter.value;
        }
      }
    });

    if (onSubmit) {
      onSubmit(activeFilters);
    }
    setActiveFilters(activeFilters);
    setFiltersVisible(false);
  }, [filters, onSubmit]);

  const clearFiltersHandler = useCallback(() => {
    initializeFilters(true);
  }, [initialFilters]);

  useEffect(() => {
    if (clearFilters) {
      clearFiltersHandler();
      setClearFilters(false);
    }
  }, [clearFilters]);

  const cancelClicked = useCallback(() => {
    setFiltersVisible(false);
  }, []);

  const renderContainer = (container, i) => {
    switch (container.type) {
      case 'radioGroup':
        return (
          <div className="filter-container" key={i.toString()}>
            <label>{t(container.label)}</label>
            <Form.Item>
              <Radio.Group
                value={container.value}
                onChange={(val) => handleChange(val, i, 'radio')}
                defaultValue={container.defaultValue}
              >
                <Space direction="vertical">
                  {container.items.map((item, j) => (
                    <Radio key={j.toString()} value={item.value}>
                      {t(item.label)}
                    </Radio>
                  ))}
                </Space>
              </Radio.Group>
            </Form.Item>
          </div>
        );
      case 'select':
        let itemsToMap;

        if (container.showIfHasValue) {
          const f = filters.find((f) => f.key === container.showIfHasValue);

          if (f) {
            if (!f.value) {
              if (container.value) {
                setFilters((prev) => prev.map((p) => {
                  if (p.key === container.key) {
                    return { ...p, value: undefined };
                  }
                  return p;
                }));
              }
              return null;
            }

            itemsToMap = container.items.filter((v) => v.group === f.value);

            if (container.value) {
              const activeGroup = container.items.find((c) => c.value === container.value)?.group;
              if (activeGroup !== f.value) {
                setFilters((prev) => prev.map((p) => {
                  if (p.key === container.key) {
                    return { ...p, value: undefined };
                  }
                  return p;
                }));
              }
            }
          }
        }

        return (
          <div className="filter-container" key={i.toString()}>
            <label>{t(container.label)}</label>
            {(itemsToMap || container.items) && (
              <Form.Item>
                <Select
                  {...getPopupContainer()}
                  showSearch
                  placeholder={t(container.placeholder)}
                  defaultValue={container.defaultValue}
                  value={container.value}
                  onChange={(val) => handleChange(val, i, 'select')}
                  allowClear
                >
                  {(itemsToMap || container.items).map((c) => (
                    <Select.Option value={c.value} key={c.value}>
                      {t(c.label)}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}
          </div>
        );
      case 'textInput':
        return (
          <div className="filter-container" key={i.toString()}>
            <label>{t(container.label)}</label>
            <Form.Item>
              <Input
                value={container.value || ''}
                onChange={(e) => handleChange(e, i, 'textInput')}
                placeholder={t(container.placeholder)}
              />
            </Form.Item>
          </div>
        );
      default:
        return null;
    }
  };

  const renderFilters = useMemo(() => (
    <Form
      name="filters"
      onFinish={applyFiltersHandler}
    >
      <Style className="filters-wrapper">
        {filters.map((container, i) => renderContainer(container, i))}
        <div className="filters-actions">
          <Button onClick={cancelClicked}>{t('Cancel')}</Button>
          <Button type="primary" htmlType="submit">{t('Dashboard::Apply')}</Button>
        </div>
      </Style>
    </Form>
  ), [filters, t]);

  return (
    <Modal
      centered
      title={(
        <ModalHeader title={title ? title : t('Dashboard::Recorded Events')} />
      )}
      onCancel={cancelClicked}
      className="filter-modal"
      open={filtersVisible}
      footer={null}
      width={300}
    >
      {renderFilters}
    </Modal>
  );
}
